import Joi from '@hapi/joi'

export const EmployeeWiseCheckRollMonthlySummaryReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("operationEntityID").messages({
        "any.invalid": `Please select valid operationEntity`,
        "any.required": `operationEntity required`
    }),
    divisionID: Joi.number().invalid(0).required().label("divisionID").messages({
        "any.invalid": `Please select valid division`,
        "any.required": `division required`
    }),
    pluckingType: Joi.string().invalid(0).required().label("pluckingType").messages({
        "any.invalid": `Please select valid Plucking Type`,
        "any.required": `Plucking Type required`
    }),
    regNumber: Joi.string().label("Registration Number").messages({
        "any.invalid": `Registration number cannot have invalid characters`,
        "any.required": `Registration Number is required`
    }),
    toDate: Joi.string().invalid("").label("To date"),
    fromDate: Joi.string().invalid("").label("From date"),
}